import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import classNames from 'classnames';
import React__default from 'react';
import { getPrefixCls } from '../../utils/getPrefix.js';
import { IconStar } from '../Icon/IconStar.js';
import { IconAvatar } from '../Icon/IconAvatar.js';
import { Pro } from '../Pro/Pro.js';
import '../../extends-30811c5e.js';
import '../../objectWithoutProperties-dd908bcc.js';
import '../IconColor/IconColorPro.js';

var prefixCls = getPrefixCls('avatar');
var Avatar = function Avatar(_ref) {
  var className = _ref.className,
    _ref$dataTestid = _ref.dataTestid,
    dataTestid = _ref$dataTestid === void 0 ? 'avatar' : _ref$dataTestid,
    image = _ref.image,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'user avatar' : _ref$alt,
    pro = _ref.pro,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size;
  return /*#__PURE__*/React__default.createElement("figure", {
    "sl-test-data": dataTestid,
    className: classNames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), size))
  }, image ? /*#__PURE__*/React__default.createElement("img", {
    className: "".concat(prefixCls, "_image"),
    alt: alt,
    src: image
  }) : /*#__PURE__*/React__default.createElement(IconAvatar, {
    className: "".concat(prefixCls, "_image")
  }), pro && /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_pro")
  }, /*#__PURE__*/React__default.createElement(IconStar, {
    className: "".concat(prefixCls, "_pro ").concat(prefixCls, "_pro-small")
  }), /*#__PURE__*/React__default.createElement(Pro, {
    dataTestid: "".concat(dataTestid, "-pro"),
    className: "".concat(prefixCls, "_pro ").concat(prefixCls, "_pro-large")
  })));
};

export { Avatar };
